// @flow
import React from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import InvertColorsOutlinedIcon from '@material-ui/icons/InvertColorsOutlined';
import { ListItem, ListItemIcon, ListItemText, Switch } from '@material-ui/core';
import { SiteThemeContext } from '../../contexts/SiteThemeProvider';

type Props = {
  classes: Object,
  t: Function,
};

const ScribeSetThemeColor = ({ classes, t }: Props) => (
  <SiteThemeContext.Consumer>
    {({ handleThemeChange, theme }) => (
      <ListItem
        style={{
          paddingLeft: 32,
        }}
      >
        <ListItemIcon>
          <InvertColorsOutlinedIcon />
        </ListItemIcon>
        <ListItemText classes={{ root: classes.listItemText }} primary={t('theme.darkMode')} />
        <ListItemIcon style={{ marginRight: -7 }}>
          <Switch color="primary" onClick={handleThemeChange} checked={theme === 'dark'} />
        </ListItemIcon>
      </ListItem>
    )}
  </SiteThemeContext.Consumer>
);
export default withTranslation()(withStyles({})(ScribeSetThemeColor));
